var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_824_13723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.913 7.08545L4.16304 7.08545C3.36096 7.08545 2.70471 7.72295 2.70471 8.50212C2.70471 9.28128 3.36096 9.91878 4.16304 9.91878L12.913 9.91878C13.7151 9.91878 14.3714 9.28128 14.3714 8.50212C14.3714 7.72295 13.7151 7.08545 12.913 7.08545ZM12.913 14.8771L4.16304 14.8771C3.36096 14.8771 2.70471 15.5146 2.70471 16.2938C2.70471 17.073 3.36096 17.7105 4.16304 17.7105L12.913 17.7105C13.7151 17.7105 14.3714 17.073 14.3714 16.2938C14.3714 15.5146 13.7151 14.8771 12.913 14.8771ZM12.913 22.6688L4.16304 22.6688C3.36096 22.6688 2.70471 23.3063 2.70471 24.0855C2.70471 24.8646 3.36096 25.5021 4.16304 25.5021L12.913 25.5021C13.7151 25.5021 14.3714 24.8646 14.3714 24.0854C14.3714 23.3063 13.7151 22.6688 12.913 22.6688ZM20.4235 27.1313L17.813 24.5955C17.5214 24.3121 17.5214 23.873 17.813 23.5896L20.4235 21.0538C20.8755 20.6005 21.663 20.9121 21.663 21.5496L21.663 26.6354C21.663 27.2588 20.8755 27.5705 20.4235 27.1313ZM21.663 22.6688L22.1005 22.6688C25.5276 22.6688 28.5901 20.2463 28.9255 16.9313C29.3047 13.1346 26.2276 9.91878 22.3922 9.91878L18.7464 9.91878C17.9443 9.91878 17.288 9.28128 17.288 8.50212C17.288 7.72295 17.9443 7.08545 18.7464 7.08545L22.3922 7.08545C28.0214 7.08545 32.5422 11.9021 31.7839 17.5121C31.1714 22.1588 26.8693 25.5021 22.0568 25.5021L21.663 25.5021",
    fill: "#FF8A1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_824_13723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 35,
    fill: "white",
    transform: "matrix(0 1 -1 0 35 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipIcon);
export default __webpack_public_path__ + "static/media/skipIcon.4adb3282.svg";
export { ForwardRef as ReactComponent };